import './index.scss';
import { useTranslation } from 'react-i18next';
import { Calendar, Clock, MapPin } from 'react-feather';
import moment from 'moment';
import { GymResource } from '../../../../store/gym-management/GymTypes';
import { getSingleOption } from '../../../../utility/Utils';
import { formatNumberToDayName } from '../../../../utility/services/get-day-names';

interface ChangeGymContentProps {
  room: GymResource;
}
const ChangeGymContent = (props: ChangeGymContentProps) => {
  const { t } = useTranslation();

  return (
    <div className="change-gym-content">
      <div className="change-gym-content-title">{props.room.name}</div>
      <div className="change-gym-content-date-time">
        <div className="card-content-icon">
          <Clock size={19} />
        </div>
        <div>
          <div className="change-gym-content-time">
            {getSingleOption(props.room.availableFrom).label} -{' '}
            {getSingleOption(props.room.availableTo).label}
          </div>
          <div className="change-gym-content-date">
            {props.room.availableDays
              .sort((a, b) => a - b)
              .map((day) => formatNumberToDayName(day))
              .join(', ')}
          </div>
        </div>
      </div>
      <div className="change-gym-content-location">
        <div className="card-content-icon">
          <MapPin size={17} />
        </div>
        <div>
          <div className="change-gym-content-location-name">
            {props.room.location.name}
          </div>
          <div className="change-gym-content-building-name">
            {props.room.building.name}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChangeGymContent;
